document.addEventListener("DOMContentLoaded", function () {
  const stockContainer = document.getElementById('stock-warning-container');
  if (!stockContainer) return;

  const variants = JSON.parse(stockContainer.dataset.stockJson);
  const stockMessageEl = stockContainer.querySelector('.stock-message');
  const dotEl = stockContainer.querySelector('.stock-dot');
  const variantIdInput = document.querySelector('input[name="id"]');

  const minThreshold = parseInt(stockContainer.dataset.min, 10) || 1;
  const maxThreshold = parseInt(stockContainer.dataset.max, 10) || 9999;
  const textSingular = stockContainer.dataset.textSingular;
  const textPlural = stockContainer.dataset.textPlural;

  // Cores controladas via CSS global (sem schema)

  function updateStockMessage(variantId) {
    const variant = variants.find(v => v.id === Number(variantId));
    if (!variant) return;

    const qty = variant.inventory_quantity;

    if (qty >= minThreshold && qty <= maxThreshold) {
      const text = qty === 1
        ? textSingular.replace('[[stock]]', qty)
        : textPlural.replace('[[stock]]', qty);
      stockMessageEl.textContent = text;
      stockContainer.style.display = 'flex';
    } else if (qty === 0) {
      stockMessageEl.textContent = 'Produto esgotado';
      stockContainer.style.display = 'flex';
    } else {
      stockContainer.style.display = 'none';
    }
  }

  updateStockMessage(variantIdInput.value);

  const observer = new MutationObserver(() => {
    updateStockMessage(variantIdInput.value);
  });

  observer.observe(variantIdInput, {
    attributes: true,
    attributeFilter: ['value']
  });

  document.querySelectorAll('input[type="radio"]').forEach((input) => {
    input.addEventListener('change', () => {
      setTimeout(() => {
        updateStockMessage(variantIdInput.value);
      }, 50);
    });
  });
});
